'use strict'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@material-ui/core'
import { DFBadge } from '../../df'

export default function PublishConfirmModal ({ open, onClose, onConfirm, scenarioName, diffData, publishing }) {
  const summary = diffData?.diff?.summary || {}
  const metricsDelta = diffData?.metricsDelta || null

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ borderBottom: '1px solid var(--df-line, #e0d8c2)', paddingBottom: 8 }}>
        <span style={{ fontSize: 16, fontWeight: 700, color: 'var(--df-ink, #1c2419)' }}>Publish Scenario</span>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 16 }}>
        <Typography variant="body1" gutterBottom style={{ color: 'var(--df-ink, #1c2419)' }}>
          Publish <strong>{scenarioName || 'this scenario'}</strong> to live routing data?
        </Typography>

        {/* Diff summary badges */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 16, marginBottom: 12 }}>
          <DFBadge>Moved: {summary.movedCount || 0}</DFBadge>
          <DFBadge>VIP changes: {summary.vipChangedCount || 0}</DFBadge>
          <DFBadge>Lock changes: {summary.lockChangedCount || 0}</DFBadge>
        </div>

        {/* Metrics delta */}
        {metricsDelta && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
            <span className="rw-pill" style={{
              background: (metricsDelta.totalOTMinutesDelta || 0) <= 0 ? '#e3eee0' : '#fbe8d6',
              color: (metricsDelta.totalOTMinutesDelta || 0) <= 0 ? '#164a2c' : '#a4502f'
            }}>
              OT delta: {Math.round(metricsDelta.totalOTMinutesDelta || 0)} min
            </span>
            <span className="rw-pill" style={{ background: 'var(--df-surface-2, #f4efe4)', color: 'var(--df-ink-3)' }}>
              Avg load delta: {Math.round(metricsDelta.avgCrewLoadDelta || 0)} min
            </span>
            <span className="rw-pill" style={{ background: 'var(--df-surface-2, #f4efe4)', color: 'var(--df-ink-3)' }}>
              Max load delta: {Math.round(metricsDelta.maxCrewLoadDelta || 0)} min
            </span>
          </div>
        )}

        <Typography variant="caption" style={{ color: 'var(--df-ink-4, #97a094)', display: 'block' }}>
          This will apply all scenario overrides to live routing assignments. A CSV of changes will be downloaded automatically.
        </Typography>
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid var(--df-line, #e0d8c2)', padding: '12px 24px' }}>
        <Button onClick={onClose} disabled={publishing} style={{ color: 'var(--df-ink-3)' }}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
          disabled={publishing}
          startIcon={publishing ? <CircularProgress size={16} color="inherit" /> : null}
          style={{ fontWeight: 600 }}
        >
          {publishing ? 'Publishing...' : 'Publish to Live'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
